@if (isModalVisible) {
  <div class="popup-overlay" (click)="popupClose()">
    <div class="popup-panel"
         role="dialog"
         aria-modal="true"
         [attr.aria-label]="'add-form-popup.title' | translate"
         (click)="$event.stopPropagation()">

      <!-- ================= Header ================= -->
      <div class="popup-header">
        <div class="popup-badge"><i class="fas fa-file-lines"></i></div>
        <div class="popup-titles">
          <h2>{{ 'add-form-popup.title' | translate }}</h2>
          <p>{{ 'add-form-popup.text' | translate }}</p>
        </div>
        <button type="button" class="popup-close" [attr.aria-label]="'general.button.close' | translate"
                (click)="popupClose()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- ================= Body ================= -->
      <form class="popup-body" [formGroup]="form">

        <!-- Form ID (custom field: existence error handling) -->
        <div class="field">
          <span class="field-label popup-hint">
            {{ 'add-form-popup.input.upload' | translate }}
            <i class="fas fa-asterisk"></i>
          </span>
          <input class="formid-input" type="text" formControlName="formID"
                 [class.has-error]="formIDExistenceError">
          @if (formIDExistenceError) {
            <div class="field-error">
              <i class="fas fa-circle-exclamation"></i>
              {{ 'add-form-popup.input.formID.subtext' | translate }}
            </div>
          }
        </div>

        <div class="field-grid">
          <form-input
            controlName="name"
            label="add-form-popup.input.name"
            messageIcon="required"/>

          <form-select-list
            controlName="category"
            label="add-form-popup.input.category"
            [listSelectItems]="formCategoryList"
            prefixTranslation="enum.form-category."
            messageIcon="required"/>
        </div>

        <div class="field">
          <form-textarea
            controlName="description"
            rows="3"
            label="add-form-popup.input.description"
            messageIcon="required"/>
        </div>

        <!-- Upload -->
        <div>
          <span class="field-label popup-hint">
            {{ 'add-form-popup.input.upload' | translate }}
            <i class="fas fa-asterisk"></i>
          </span>
          <single-upload-zone
            title="form"
            [clearUploadEvent]="clearUploadEventSubject.asObservable()"
            (fileUploaded)="setFileUploaded($event)"/>
        </div>

      </form>

      <!-- ================= Footer ================= -->
      <div class="popup-footer">
        <span class="popup-hint">
          <i class="fas fa-asterisk"></i>
          {{ 'general.popup.required-fields' | translate }}
        </span>
        <button type="button" class="btn-ghost" (click)="popupClose()">
          {{ 'add-form-popup.button.cancel' | translate }}
        </button>
        <button type="button" class="btn-add" [disabled]="isButtonValidate()" (click)="onClickValidate()">
          <i class="fas fa-plus"></i>
          {{ 'add-form-popup.button.add-form' | translate }}
        </button>
      </div>

    </div>
  </div>
}
<unsaved-changes-popup [hasUnsavedChanges]="isModalVisible && hasPendingChanges"/>
